const cache = new Map()

export function getCachedResult(key) {
  return cache.get(key)
}

export function setCachedResult(key, data) {
  cache.set(key, data)
}

export function clearSelectCache(endpoint) {
  if (!endpoint) {
    cache.clear()
    return
  }
  const prefix = `${process.env.VUE_APP_API_URL}/${endpoint}`
  for (const k of cache.keys()) {
    if (k.startsWith(prefix)) {
      cache.delete(k)
    }
  }
}
